import { batch } from 'react-redux';
import { userAPI } from 'entities/user';
import { AppThunk } from 'store';
import { AuthForm } from 'entities/user';
import { STATUS_LOADING } from 'common/constants/statusLoading';
import setAuthData from 'common/utils/auth/setAuthData';
import resetAuthData from 'common/utils/auth/resetAuthData';
import parseAuthData from 'common/utils/auth/parseAuthData';
import EVENT_TYPES_GTM from 'common/constants/eventTypesGTM';
import addGTMEvent from 'common/utils/addGTMEvent';
import { USER_TYPES } from 'common/utils/userTypes';
import getTranslateIdFromResponseError from 'common/utils/getTranslateIdFromResponseError';
import { checkIsUserCountourB } from 'entities/user';
import {
  createHiddenIFrame,
  checkIsIFrameLoaded
} from 'shared/utils';
import { getContourBURL } from 'entities/application';
import { isIOS, isSafariBrowser } from 'common/utils/checkBrowserType';

import config from 'config';

import { IS_DIFFERENT_CONTOURS } from 'entities/application';
import { CROSS_ORIGIN_MESSAGE_TYPES } from 'entities/user';

import slice from '../reducer/slice';
import { applicationActions } from 'entities/application';
import { intl } from 'i18n';

const { setUserType, setUserLoadingStatus } = slice.actions;
const { setErrorNotice } = applicationActions;

const operation = (authForm: AuthForm): AppThunk => async (dispatch) => {
  try {
    dispatch(setUserLoadingStatus(STATUS_LOADING.load));

    const { data: { data } } = await userAPI.getAuthTokens(authForm);

    const authData = parseAuthData(data);

    if (IS_DIFFERENT_CONTOURS && !isIOS && !isSafariBrowser && checkIsUserCountourB(authData.contourType)) {
      const contourBIframe = createHiddenIFrame(config.contourB);
      await checkIsIFrameLoaded(contourBIframe);
      contourBIframe.contentWindow?.postMessage({
        type: CROSS_ORIGIN_MESSAGE_TYPES.token,
        data: data.refresh_token
      }, config.contourB);
      setTimeout(() => {
        window.location.replace(getContourBURL());
      }, 1000);
    } else {
      setAuthData(authData);
      addGTMEvent(EVENT_TYPES_GTM.login, { userId: authData.clientCode, userType: authData.userType });
      window.location.reload();
    }

  } catch (e) {
    const translateId = await getTranslateIdFromResponseError(e);
    batch(() => {
      dispatch(setErrorNotice({
        title: intl.formatMessage(
          { id: translateId },
          { userName: authForm.login }
        )
      }));
      resetAuthData();
      dispatch(setUserLoadingStatus(STATUS_LOADING.error));
      dispatch(setUserType(USER_TYPES.unautorized));
    });
  }
};

export default operation;
